define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/action/AggregateBaseController",
	"csi/gallery/NewMixin"
], function(array,declare,csi,AggregateBaseController,NewMixin) {

	return declare([AggregateBaseController, NewMixin], {
		// Boolean: in gallery views, there should be no editing after AggregateFrom action
		bEditHeading: false,

		constructor: function(/*Object*/params) {
			// summary: reset node since they are being created
			this.m_urlNode = null;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add appended rows to request
			return this.inherited(arguments, [urlsNew.concat(this.urlsAppended)]);
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return csi.transform(this.urlsAppended, function(url) { return this.m_cache.getNode(url); }, this) || [];
		},

		preProcess: function() {
			// summary: call mixin before continuing
			if (this._newPreProcess()) {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: call mixin
			this._newPostProcess();
		}
	});
});